import React, { ReactElement } from 'react';

// Lloyds svg image exports
export function LloydsPenSvg(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.135 6.51193C11.7853 2.54009 13.1595 2.11756 13.1595 1.18798C13.1595 0.258404 12.3006 0.00488281 12.3006 0.00488281V9.63869C12.9018 9.8077 13.3313 10.3147 13.3313 10.9063C13.3313 11.6669 12.7301 12.2584 11.9571 12.2584C11.184 12.2584 10.5828 11.6669 10.5828 10.9063C10.5828 10.3147 11.0123 9.8077 11.6135 9.63869V0.173897C11.6135 0.173897 10.7546 0.427418 10.7546 1.357C10.7546 2.28657 12.1288 2.70911 8.77914 6.68094C5.42945 10.6528 5 11.2443 5 11.2443L7.40491 18.5964H16.5951L19 11.2443C18.8282 11.1598 18.3988 10.6528 15.135 6.51193ZM7.06128 19.864H16.595V24.0049H7.06128V19.864Z"
        fill="#006A4D"
      />
    </svg>
  );
}

export function LloydsFormSvg(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0703 0.00292969V5.02385H21.8995L16.0703 0.00292969ZM17.0755 11.3502H6.82422V9.64307H17.0755C17.0755 9.54265 17.0755 11.3502 17.0755 11.3502ZM17.0755 15.7686H6.82422V13.9611H17.0755V15.7686ZM17.0755 20.0866H6.82422V18.3795H17.0755V20.0866ZM14.7638 0.00292969H2V24.0029H22V6.32929H14.7638V0.00292969Z"
        fill="#006A4D"
      />
    </svg>
  );
}

export function LloydsPostCoverSvg(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 4.00684H0L12 11.0941L24 4.00684ZM12 12.5974L0 5.61757V20.0068H24V5.61757L12 12.5974Z"
        fill="#006A4D"
      />
    </svg>
  );
}

// BOS svg image exports
export function BOSPenSvg(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.135 6.51095C11.7853 2.53912 13.1595 2.11658 13.1595 1.187C13.1595 0.257427 12.3006 0.00390625 12.3006 0.00390625V9.63771C12.9018 9.80672 13.3313 10.3138 13.3313 10.9053C13.3313 11.6659 12.7301 12.2574 11.9571 12.2574C11.184 12.2574 10.5828 11.6659 10.5828 10.9053C10.5828 10.3138 11.0123 9.80672 11.6135 9.63771V0.17292C11.6135 0.17292 10.7546 0.426441 10.7546 1.35602C10.7546 2.2856 12.1288 2.70813 8.77914 6.67996C5.42945 10.6518 5 11.2433 5 11.2433L7.40491 18.5955H16.5951L19 11.2433C18.8282 11.1588 18.3988 10.6518 15.135 6.51095ZM7.06128 19.863H16.595V24.0039H7.06128V19.863Z"
        fill="#005BA2"
      />
    </svg>
  );
}

export function BOSFormSvg(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0703 0.00292969V5.02385H21.8995L16.0703 0.00292969ZM17.0755 11.3502H6.82422V9.64307H17.0755C17.0755 9.54265 17.0755 11.3502 17.0755 11.3502ZM17.0755 15.7686H6.82422V13.9611H17.0755V15.7686ZM17.0755 20.0866H6.82422V18.3795H17.0755V20.0866ZM14.7638 0.00292969H2V24.0029H22V6.32929H14.7638V0.00292969Z"
        fill="#005BA2"
      />
    </svg>
  );
}

export function BOSPostCoverSvg(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 4.00488H0L12 11.0921L24 4.00488ZM12 12.5955L0 5.61562V20.0049H24V5.61562L12 12.5955Z"
        fill="#005BA2"
      />
    </svg>
  );
}
